import api from '@/configs/GlobalRequestHandler.js';

export default {
  getUsers: (params) => {
    return api.getRequestWithBody('/admin/users', { params });
  },
  deleteUser: (id) => {
    return api.deleteRequest(`/admin/users/${id}`);
  },
  changePassword: (body) => {
    return api.putRequestWithBody('/user/change_password', body);
  },
  blockUser: (id) => {
    return api.putRequestWithBody(`/admin/users/block/${id}`, {});
  },
  unblockUser: (id) => {
    return api.putRequestWithBody(`/admin/users/unblock/${id}`, {});
  },
  markVerified: (id) => {
    return api.putRequestWithBody(`/admin/users/mark_verified/${id}`, {});
  },
  loginAsUser: (userId) => {
    return api.postRequest(`/admin/users/login-as/${userId}`);
  },
  forceLogoutUser: (userId) => {
    return api.postRequest(`/admin/users/force-logout/${userId}`);
  },
  getUsersMinimum: () => {
    return api.getRequest('/admin/users/minimum');
  },
  getProfile: () => {
    return api.getRequest('/users');
  },
  updateProfile: (body) => {
    return api.putRequestWithBody('/users', body);
  },
  updateDomain: (domain) => {
    return api.putRequestWithBody('/users/domain', { domain });
  },
  updateTheme: (theme_primary_color, theme_accent_color) => {
    return api.putRequestWithBody('/users/theme', {
      theme_primary_color,
      theme_accent_color,
    });
  },
  updateAdminUserDomain: (userId, domain) => {
    return api.putRequestWithBody(`/admin/users/domain/${userId}`, { domain });
  },
  listUserDomains: (status = 'pending') => {
    return api.getRequest('/admin/users/domains', { params: { status } });
  },
  updateDomainReady: (userId, ready) => {
    return api.putRequestWithBody(`/admin/users/domain/${userId}/ready`, { ready });
  },
  updateLogo: (body) => {
    return api.putRequestWithBody('/users/logo', body);
  },
  updateProfileImage: (body) => {
    return api.putRequestWithBody('/users/profile', body);
  },
  markWalletModalSeen: () => {
    return api.putRequestWithBody('/user/seen-wallet-modal', {});
  },
  markAffiliationModalSeen: () => {
    return api.putRequestWithBody('/user/seen-affiliation-modal', {});
  },
  getGlobalSettings: () => {
    return api.getRequest('/settings');
  },
  updateGlobalSettings: (body) => {
    return api.putRequestWithBody('/admin/settings', body);
  },
  toggleAffiliate: () => {
    return api.putRequestWithBody('/user/affiliate', {});
  },
  send2FACode: () => {
    return api.postRequest('/user/2fa/send-code');
  },
  verify2FACode: (code) => {
    return api.postRequestWithBody('/user/2fa/verify-code', { code });
  },
  setupTotp: () => {
    return api.postRequest('/user/2fa/totp/setup');
  },
  confirmTotp: (code) => {
    return api.postRequestWithBody('/user/2fa/totp/confirm', { code });
  },
  disable2FA: (password) => {
    return api.postRequestWithBody('/user/2fa/disable', { password });
  },
  deleteAccount: (password, confirmation) => {
    return api.postRequestWithBody('/user/delete-account', { password, confirmation });
  },
  mark2FaModalSeen: () => {
    return api.putRequestWithBody('/user/2fa/seen-modal', {});
  },
  getFirstCouponOffer: () => {
    return api.getRequest('/user/first-coupon-offer');
  },
  markFirstCouponModalSeen: () => {
    return api.putRequestWithBody('/user/seen-first-coupon-modal', {});
  },
  createPlanCheckout: (plan = 'MENSAL') => {
    return api.postRequestWithBody('/user/plan/checkout', { plan });
  },
  getPlanPaymentStatus: (id) => {
    const q = id ? `?id=${id}` : '';
    return api.getRequest(`/user/plan/payment${q}`);
  },
  sandboxConfirmPlanPayment: () => {
    return api.postRequest('/user/plan/payment/sandbox-confirm');
  },
  createBlackFridayCheckout: (email, token) => {
    return api.postRequestWithBody('/black-friday/plan/checkout', {
      email,
      token,
      plan: 'ANUAL',
    });
  },
  blackFridayPlanStatus: (email, token, id) => {
    return api.postRequestWithBody('/black-friday/plan/status', { email, token, id });
  },
  sandboxConfirmBlackFriday: (email, token) => {
    return api.postRequestWithBody('/black-friday/plan/sandbox-confirm', { email, token });
  },
  getRemarketingStatus: (id) => {
    const q = id ? `?id=${id}` : '';
    return api.getRequest(`/user/remarketing${q}`);
  },
  createRemarketingCheckout: () => {
    return api.postRequest('/user/remarketing/checkout');
  },
  sandboxConfirmRemarketingPayment: () => {
    return api.postRequest('/user/remarketing/payment/sandbox-confirm');
  },
  getRemarketingQR: () => {
    return api.getRequest('/user/remarketing/qr');
  },
  sandboxConnectRemarketing: () => {
    return api.postRequest('/user/remarketing/instance/sandbox-connect');
  },
  disconnectRemarketing: () => {
    return api.postRequest('/user/remarketing/instance/disconnect');
  },
  updateRemarketingSettings: (body) => {
    return api.putRequestWithBody('/user/remarketing/settings', body);
  },
  logout: () => {
    return api.postRequest('/logout');
  },
  updateUserProfile: (userId, userData) => {
    // Endpoint admin para atualizar perfil de qualquer usuário
    return api.putRequestWithBody(`/admin/users/profile/${userId}`, userData);
  },
  getAdminUserDetails: (userId) => {
    return api.getRequest(`/admin/users/details/${userId}`);
  },
  updateAdminRemarketing: (userId, body) => {
    return api.putRequestWithBody(`/admin/users/${userId}/remarketing`, body);
  },
  updateAdminAcademy: (userId, body) => {
    return api.putRequestWithBody(`/admin/users/${userId}/academy`, body);
  },
}
